import { Routes } from '@angular/router';
import { authGuard } from './modules/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./modules/inicio/inicio.component').then((m) => m.InicioComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
